import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const LoginModule = {
    namespaced: true,
    state: {
        general:{
            code:"",
            title:"",
            credit:"",

            program:{

            },
            instructor:[],
            studentsYearofStudy:[],
            preRequest: [],
            coRequest: [],
            campus: [],
            modification:{
                dateTime:"",
                by:""
            }

        },
        syllabus:{
            description : [],
            objectives : "",
            improvement : "",
            hoursPerSemester:{
                lecture:0,
                lab:0,
                selfStudy: 0
            }
        },
        references:{
            book:[],
            journal:[]
        },
    },

    mutations: {
        general(state, obj) {
            state.general = obj;
        },
        syllabus(state, obj) {
            state.syllabus = obj;
        },


        references(state, obj) {
            state.references = obj;
        },

    },

    actions: {

    },

    getters: {
        general(state) {
            return state.general;
        },
        syllabus(state) {
            return state.syllabus;
        },
        references(state) {
            return state.references;
        },

    },
};
export default LoginModule;
